import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "base-pagination" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("‹")
const _hoisted_3 = {
  key: 0,
  class: "base-pagination__item base-pagination__item--ellipsis"
}
const _hoisted_4 = {
  key: 1,
  class: "base-pagination__item base-pagination__item--ellipsis"
}
const _hoisted_5 = /*#__PURE__*/_createTextVNode("›")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_base_button = _resolveComponent("base-button")!

  return (_openBlock(), _createElementBlock("ul", _hoisted_1, [
    _createElementVNode("li", {
      class: _normalizeClass(["base-pagination__item base-pagination__item--prev", { 'base-pagination__item--disabled': !_ctx.hasPrev }])
    }, [
      _createVNode(_component_base_button, {
        minimal: "",
        disabled: !_ctx.hasPrev,
        onClick: _ctx.prev
      }, {
        default: _withCtx(() => [
          _hoisted_2
        ]),
        _: 1
      }, 8, ["disabled", "onClick"])
    ], 2),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.leftGroup, (page) => {
      return (_openBlock(), _createElementBlock("li", {
        key: page.number,
        class: _normalizeClass(["base-pagination__item", {
				'base-pagination__item--current': _ctx.isCurrent(page),
			}])
      }, [
        _createVNode(_component_base_button, {
          minimal: "",
          onClick: ($event: any) => (_ctx.to(page))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(page.number), 1)
          ]),
          _: 2
        }, 1032, ["onClick"])
      ], 2))
    }), 128)),
    (_ctx.hasFirstEllipsis)
      ? (_openBlock(), _createElementBlock("li", _hoisted_3, " … "))
      : _createCommentVNode("", true),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.centerGroup, (page) => {
      return (_openBlock(), _createElementBlock("li", {
        key: page.number,
        class: _normalizeClass(["base-pagination__item", {
				'base-pagination__item--current': _ctx.isCurrent(page),
			}])
      }, [
        _createVNode(_component_base_button, {
          minimal: "",
          onClick: ($event: any) => (_ctx.to(page))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(page.number), 1)
          ]),
          _: 2
        }, 1032, ["onClick"])
      ], 2))
    }), 128)),
    (_ctx.hasSecondEllipsis)
      ? (_openBlock(), _createElementBlock("li", _hoisted_4, " … "))
      : _createCommentVNode("", true),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rightGroup, (page) => {
      return (_openBlock(), _createElementBlock("li", {
        key: page.number,
        class: _normalizeClass(["base-pagination__item", {
				'base-pagination__item--current': _ctx.isCurrent(page),
			}])
      }, [
        _createVNode(_component_base_button, {
          minimal: "",
          onClick: ($event: any) => (_ctx.to(page))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(page.number), 1)
          ]),
          _: 2
        }, 1032, ["onClick"])
      ], 2))
    }), 128)),
    _createElementVNode("li", {
      class: _normalizeClass(["base-pagination__item base-pagination__item--next", { 'base-pagination__item--disabled': !_ctx.hasNext }])
    }, [
      _createVNode(_component_base_button, {
        minimal: "",
        disabled: !_ctx.hasNext,
        onClick: _ctx.next
      }, {
        default: _withCtx(() => [
          _hoisted_5
        ]),
        _: 1
      }, 8, ["disabled", "onClick"])
    ], 2)
  ]))
}